import React from "react";
import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { School, Upgrade, People, Password, Savings, Description, PrivacyTip, Help } from '@mui/icons-material';
import ListIcon from '@mui/icons-material/List'; // had to be imported separately since List name already used
import { useLocation, useNavigate } from "react-router-dom";

export default function DashboardDrawer({ setOpen, isCollector }) {

  const pathInfo = [
    { path: "", text: 'Subscriptions', icon: <ListIcon /> },
    { path: '/upgrade', text: isCollector ? 'Manage Collector Status' : 'Upgrade to Collector', icon: <Upgrade /> },
    { path: '/update-profile', text: 'Update Contact Info', icon: <People /> },
    { path: '/change-password', text: 'Change Password', icon: <Password /> },
    // { path: '/all-watches', text: 'All Watches', icon: <AllInclusive /> },
  
    { path: '/tutorial', text: 'Watch Tutorial', icon: <School /> },
    { path: '/donate', text: 'Donate', icon: <Savings /> },
    { path: '/terms', text: 'Terms', icon: <Description /> },
    { path: '/privacy', text: 'Privacy', icon: <PrivacyTip /> },
  ];

  const { pathname } = useLocation();
  const navigate = useNavigate();
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    // Clear the interval when the component unmounts
    return () => clearTimeout(timerRef.current);
  }, []);

  const handleClick = (path) => {
    navigate("/dashboard" + path);
    timerRef.current = setTimeout(() => setOpen(false), 500);
  }

  const n = 4;
  return (
    <div style={{ marginTop: 14, marginLeft: 4 }}>
      <List>
        {pathInfo
          .slice(0, n)
          .filter((info, index) => (info.path !== '/update-profile' || isCollector))
          .map((info, index) => (
          <ListItem key={info.text} disablePadding>
            <ListItemButton onClick={() => handleClick(info.path)} selected={"/dashboard" + info.path === pathname}>
              <ListItemIcon>
                {info.icon}
              </ListItemIcon>
              <ListItemText primary={info.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ bgcolor: 'black' }} />
      <List>
        {pathInfo.slice(n).map((info, index) => (
          <ListItem key={info.text} disablePadding >
            <ListItemButton onClick={() => handleClick(info.path)}selected={"/dashboard" + info.path === pathname}>
              <ListItemIcon>
                {info.icon}
              </ListItemIcon>
              <ListItemText primary={info.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ bgcolor: 'black' }} />
      <List>
        <ListItem key="Help" disablePadding>
          <ListItemButton href="mailto:help@watchexchanger.com">
            <ListItemIcon>
              <Help />
            </ListItemIcon>
            <ListItemText primary="Help" />
          </ListItemButton>
        </ListItem>
      </List>
    </div>
  );
}